import {useUser} from "../../../auth/AuthProvider";
import React, {useState} from "react";
import {ApiUrl} from "../../../auth/authMethods";
import LoadingButton from "@mui/lab/LoadingButton";
import DownloadIcon from "@mui/icons-material/Download";

export default function FilesAttachedReport(){
    const { user } = useUser();
    const [loading, setLoading] = useState(false);

    const handleDownload = async () => {
        try {
            setLoading(true);

            const response = await fetch(`${ApiUrl}/pedidos/report/files-attached`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.token}`,
                    'Accept': 'application/octet-stream'
                }
            });

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'relatorio_arquivos-anexados.xlsx';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            console.error('Erro ao baixar relatório:', error);
        } finally {
            setLoading(false);
        }
    };

    // Retorna null se o usuário não for admin
    if (!user?.isAdmin) {
        return null;
    }

    return (
        <LoadingButton
            onClick={handleDownload}
            loading={loading}
            loadingPosition="start"
            startIcon={<DownloadIcon />}
            variant="contained"
            color="primary"
            className="ms-2 "
        >
            Arquivos anexados
        </LoadingButton>
    );
}